<script>
import bus from "@/bus";
import Loader from "./Loader.vue";

export default {
  name: "Grid",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Array,
      default() {
        return [];
      },
    },
    columns: {
      type: Array,
      required: true,
    },
    buttons: {
      type: Array,
      default() {
        return [];
      },
    },
    sort: {
      type: Object,
      default() {
        return {
          index: null,
          order: 0,
        };
      },
    },
    fakedata: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    computeIcon(index) {
      if (index !== this.sort.index)
        return "sort";
      return this.sort.order === 1 ? "sort-down" : "sort-up";
    },
    setSort(index) {
      this.$emit("sort", index);
    },
    buttonHandler(id, buttonId, idx) {
      // General button click handler
      bus.emit(`${buttonId}`, { id, idx });
    },
  },
  components: { Loader }
};
</script>

<template>
  <table class="w-full border border-gray-300 border-solid bg-white border-collapse rounded">
    <thead>
      <tr>
        <th v-for="(col, index) in columns" :key="col.id" :class="sort.index === index ? 'bg-gray-100' : 'bg-white'"
          class="text-gray-700 cursor-pointer select-none px-6 py-3 border border-solid border-gray-300 capitalize"
          @click="setSort(index)">
          {{ $t(col.label) || col.id }}
          <font-awesome-icon :icon="computeIcon(index)"
            :class="sort.index === index ? 'text-airbnbBlue' : 'text-gray-400'" />
        </th>
        <th v-if="buttons.length > 0"
          class="text-gray-700 select-none px-6 py-3 border border-solid bg-white border-gray-300 capitalize">
          {{ $t("components.grid.action") }}
        </th>
      </tr>
    </thead>
    <tbody v-if="loading">
      <tr v-for="index in 6" :key="index" :class="index % 2 == 0 ? 'bg-white' : 'bg-gray-100'"
        :style="{ opacity: 1 / index }">
        <td v-for="col in columns" :key="col.id" class="px-6 py-3 border border-solid border-gray-300">
          <span class="text-placeholder text-transparent rounded-full select-none">
            {{ col.placeholder || $t(col.label) || col.id }}
          </span>
        </td>
        <td class="flex flex-row justify-around border border-solid border-gray-300">
          <button class="text-placeholder text-transparent p-3 my-2 rounded">
            {{ $t("components.grid.button") }}
          </button>
        </td>
      </tr>
    </tbody>
    <tbody v-else-if="rows.length > 0" data-cy="gridBody">
      <tr v-for="(row, index) in rows" :key="`${row.id}-${index}`" :class="index % 2 == 0 ? 'bg-gray-100' : 'bg-white'"
        class="text-gray-700" data-cy="gridRow">
        <td v-for="(val, rowIdx) in row.values" :key="`${row.id}-${rowIdx}-${val}`"
          class="border border-solid border-gray-300 px-6 py-3">
          <span v-if="val === null">NULL</span>
          <span v-else-if="val.list === undefined">{{ val }}</span>
          <div v-else>
            <div v-for="subElement in val.list" :key="subElement.id" class="flex flex-row">
              <span :class="subElement.classes">{{ subElement.text }}</span>
            </div>
          </div>
        </td>
        <td v-if="buttons.length > 0" class="border-b border-solid border-gray-300 flex flex-row justify-around">
          <div v-if="!buttonLoading">
            <button v-for="button in buttons" :key="button.id" class="text-white p-3 my-2 rounded"
              :class="`bg-${button.color}`" :data-cy="`btn-${button.id}`"
              @click="buttonHandler(row.id, button.id, index)">
              {{ $t(button.label) }}
            </button>
          </div>
          <Loader v-else class="block mx-auto mb-2" />

        </td>
      </tr>
    </tbody>
    <tbody v-else>
      <tr>
        <td :colspan="columns.length + 1" class="text-center p-4 text-gray-700">
          {{ $t("components.grid.no_data") }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
* {
  will-change: width;
}

th {
  transition: width 300ms;
}

.text-placeholder {
  background-color: #bdbdbd;
  animation: loading 2s infinite;
}

@keyframes loading {
  0% {
    background-color: #e0e0e0;
  }

  50% {
    background-color: #bdbdbd;
  }

  100% {
    background-color: #e0e0e0;
  }
}
</style>
